module.exports = __webpack_public_path__ + "img/buddy_nose-03.cc884ec0.svg";